// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"customcheckbox_checkboxLabel__O8UuJ","customCheckbox":"customcheckbox_customCheckbox__HviPt"};